import 'angular';

import '../api/api.module';
import '../core/core.module.ajs';
import '../customers/customers.module';
import '../grids/grids.module';
import '../messages/messages.module.ajs';

import { downgradeComponent } from '@angular/upgrade/static';

import { AddVehicleFromBranchCtrl }        from './vehicle.add-from-branch.ajs';
import { VehicleAdvertisingComponent }     from './vehicle.advertising.component';
import { VehicleBranchHistoryLiteCtrl }    from './vehicle.branch-history';
import { VehicleEventsComponent }          from './vehicle.events.component';
import { VehicleFollowUpNotesLiteCtrl }    from './vehicle.follow-up-notes';
import { VehicleFormSettingsLiteCtrl }     from './vehicle.form-settings';
import { VehicleHistoryCtrl }              from './vehicle.history.ajs';
import { VehicleHistoryReportCtrl }        from './vehicle.history.report.ajs';
import { VehicleHistoryService }           from './vehicle.history.service.ajs';
import { VehicleImportedHistoryComponent } from './vehicle.imported-history.component';
import { VehicleInspectionsComponent }     from './vehicle.inspections.component';
import { VehicleInvoicesComponent }        from './vehicle.invoices.component';
import { VehicleLiteCtrl }                 from './vehicle';
import { VehicleService }                  from './vehicle.service.ajs';
import { VehiclesLiteCtrl }                from './vehicles';
import { VehicleTransactionComponent }     from './vehicle.transaction.component';
import { VehicleTransactionsComponent }    from './vehicle.transactions.component';
import { VehicleTransferOwnerLiteCtrl }    from './vehicle.transfer-owner';

angular.module('app-lite.vehicles', [
  'app-lite.api',
  'app-lite.core',
  'app-lite.customers',
  'app-lite.grids',
  'app-lite.messages'
]).controller('AddVehicleFromBranchCtrl',     AddVehicleFromBranchCtrl)
  .controller('VehicleBranchHistoryLiteCtrl', VehicleBranchHistoryLiteCtrl)
  .controller('VehicleFollowUpNotesLiteCtrl', VehicleFollowUpNotesLiteCtrl)
  .controller('VehicleFormSettingsLiteCtrl',  VehicleFormSettingsLiteCtrl)
  .controller('VehicleHistoryCtrl',           VehicleHistoryCtrl)
  .controller('VehicleHistoryReportCtrl',     VehicleHistoryReportCtrl)
  .controller('VehicleLiteCtrl',              VehicleLiteCtrl)
  .controller('VehiclesLiteCtrl',             VehiclesLiteCtrl)
  .controller('VehicleTransferOwnerLiteCtrl', VehicleTransferOwnerLiteCtrl)
  .directive('worVehicleAdvertising',     downgradeComponent({ component: VehicleAdvertisingComponent })     as ng.IDirectiveFactory)
  .directive('worVehicleEvents',          downgradeComponent({ component: VehicleEventsComponent })          as ng.IDirectiveFactory)
  .directive('worVehicleImportedHistory', downgradeComponent({ component: VehicleImportedHistoryComponent }) as ng.IDirectiveFactory)
  .directive('worVehicleInspections',     downgradeComponent({ component: VehicleInspectionsComponent })     as ng.IDirectiveFactory)
  .directive('worVehicleInvoices',        downgradeComponent({ component: VehicleInvoicesComponent })        as ng.IDirectiveFactory)
  .directive('worVehicleTransaction',     downgradeComponent({ component: VehicleTransactionComponent })     as ng.IDirectiveFactory)
  .directive('worVehicleTransactions',    downgradeComponent({ component: VehicleTransactionsComponent })    as ng.IDirectiveFactory)
  .service('vehicleApi',        VehicleService)
  .service('vehicleHistoryApi', VehicleHistoryService);
